import { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";
import Icon from "../../../components/AppIcon";

const emptyForm = {
  title: "",
  description: "",
  keyPoints: "",
  icon: "target",
  order: 0
};

const MethodologyAdmin = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);

  const load = async () => {
    const res = await api.get("api/methodology");
    setList(res.data.data || []);
  };

  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    const payload = {
      ...form,
      keyPoints: form.keyPoints
        .split(",")
        .map((k) => k.trim())
        .filter(Boolean)
    };
    const remove = async (id) => {
  if (!window.confirm("Delete this step?")) return;

  try {
    await api.delete(`/api/methodology/${id}`);
    load();
  } catch (err) {
    console.error("Delete failed:", err.response?.data);
    alert("Delete failed – check backend route");
  }
};


    if (editingId) {
      await api.put(`/api/methodology/${editingId}`, payload);
    } else {
      await api.post("/api/methodology", payload);
    }

    setForm(emptyForm);
    setEditingId(null);
    load();
  };

  const edit = (item) => {
    setEditingId(item._id);
    setForm({
      ...item,
      keyPoints: item.keyPoints.join(", ")
    });
  };

  const remove = async (id) => {
    const ok = window.confirm("Delete this methodology step?");
    if (!ok) return;

    await api.delete(`/api/methodology/${id}`);
    load();
  };

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold">Methodology</h1>

      <div className="grid lg:grid-cols-3 gap-6">
        {/* FORM */}
        <div className="lg:col-span-1">
          <div className="bg-white border rounded-xl p-6 space-y-4">
            <h2 className="font-semibold">
              {editingId ? "Edit Step" : "Add Step"}
            </h2>

            {[
              ["Title", "title"],
              ["Description", "description"],
              ["Icon (lucide name)", "icon"],
              ["Order", "order"],
              ["Key Points (comma separated)", "keyPoints"]
            ].map(([label, key]) => (
              <div key={key}>
                <label className="text-xs font-medium text-gray-600">
                  {label}
                </label>
                <input
                  className="w-full mt-1 border rounded px-3 py-2 text-sm"
                  value={form[key]}
                  onChange={(e) =>
                    setForm({ ...form, [key]: e.target.value })
                  }
                />
              </div>
            ))}

            <button
              onClick={save}
              className="w-full bg-blue-600 text-white py-2 rounded"
            >
              {editingId ? "Update Step" : "Save Step"}
            </button>
          </div>
        </div>

        {/* LIST */}
        <div className="lg:col-span-2">
          <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
            {list.map((f) => (
              <div
                key={f._id}
                className="border rounded-xl p-5 flex flex-col justify-between"
              >
                <div className="space-y-3">
                  <div className="flex items-center gap-2">
                    <Icon name={f.icon || "target"} />
                    <h3 className="font-semibold text-sm">{f.title}</h3>
                  </div>

                  <p className="text-xs text-gray-500">
                    {f.description}
                  </p>

                  <ul className="list-disc pl-4 text-xs">
                    {f.keyPoints?.map((k, i) => (
                      <li key={i}>{k}</li>
                    ))}
                  </ul>
                </div>

                <div className="flex justify-between pt-4 text-xs">
                  <button
                    onClick={() => edit(f)}
                    className="text-indigo-600"
                  >
                    Edit
                  </button>

                  <button
                    onClick={() => remove(f._id)}
                    className="text-red-600"
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MethodologyAdmin;
